import React from 'react';

import { buildColumn, EditableColumnConfig } from '~components/table-view';
import WorkerFocusAction from '~weekly-planner/components/WorkerFocusAction';

import ConflictAppointment from './ConflictAppointment';

const getConflictsColumns = () => {
  const columnsList: EditableColumnConfig[] = [
    {
      id: 'appointment',
      header: 'Appointment',
      type: 'custom',
      props: {
        meta: {
          renderCustom: (_: boolean, row: any) => {
            if (!row) return null;
            const { start_time, date } = row.original ?? row;
            const client = row.original?.client ?? row.client;
            return React.createElement(ConflictAppointment, {
              date,
              start_time,
              client,
            });
          },
        },
      },
    },
    {
      id: 'worker',
      header: 'Worker',
      type: 'text',
      accessorFn: (row) => row.user?.full_name,
    },
    {
      id: 'conflict_type',
      header: 'Conflict',
      type: 'text',
    },
    {
      id: 'actions',
      header: '',
      type: 'custom',
      props: {
        meta: {
          renderCustom: (_: never, row: any) => {
            if (!row) return null;
            const userId = row.user?.id;
            return React.createElement(WorkerFocusAction, { userId });
          },
        },
      },
    },
  ];

  return columnsList.map(buildColumn);
};

export default getConflictsColumns;
